import * as React from 'react';
import type { SVGProps } from 'react';
const SvgInstagram = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    {...props}
  >
    <path
      fill='currentColor'
      d='m16 11.37-.99.147zM12.63 8l-.147.99zm4.87-2.5a1 1 0 1 0 0 2zm.01 2a1 1 0 1 0 0-2zM7 3h10V1H7zm10 0a4 4 0 0 1 4 4h2a6 6 0 0 0-6-6zm4 4v10h2V7zm0 10a4 4 0 0 1-4 4v2a6 6 0 0 0 6-6zm-4 4H7v2h10zM7 21a4 4 0 0 1-4-4H1a6 6 0 0 0 6 6zm-4-4V7H1v10zM3 7a4 4 0 0 1 4-4V1a6 6 0 0 0-6 6zm12.01 4.517a3 3 0 0 1-.304 1.821l1.775.922a5 5 0 0 0 .508-3.037zm-.304 1.821a3 3 0 0 1-1.314 1.298l.9 1.787a5 5 0 0 0 2.19-2.163zm-1.314 1.298a3 3 0 0 1-1.825.283l-.318 1.974a5 5 0 0 0 3.042-.47zm-1.825.283a3 3 0 0 1-1.645-.84l-1.414 1.413a5 5 0 0 0 2.74 1.401zm-1.645-.84a3 3 0 0 1-.84-1.646l-1.975.318a5 5 0 0 0 1.4 2.741zm-.84-1.646a3 3 0 0 1 .282-1.825l-1.787-.9a5 5 0 0 0-.47 3.043zm.282-1.825a3 3 0 0 1 1.298-1.314L9.74 7.519a5 5 0 0 0-2.163 2.19zm1.298-1.314a3 3 0 0 1 1.821-.305l.294-1.978a5 5 0 0 0-3.037.508zm1.821-.305a3 3 0 0 1 1.682.846l1.414-1.414a5 5 0 0 0-2.802-1.41zm1.682.846a3 3 0 0 1 .846 1.682l1.978-.294a5 5 0 0 0-1.41-2.802zM17.5 7.5h.01v-2h-.01z'
    />
  </svg>
);
export default SvgInstagram;
